// extracted by mini-css-extract-plugin
export default {"container":"tuPK8pU6vayYsrhwJv0r","tabsText":"BsqDDvE5JYtuw4mlMsw_","tabsIcon":"kiNLhkRhmn7irFJyBlra"};